module.exports = __webpack_public_path__ + "static/globe_bg_desktop-a30d9f148b5b3c0a82a4c939df41b565.jpg";